import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
export const _updateCircular = createAction("UPDATE_CIRCULAR");
export default createReducer(
  {
    [_updateCircular]: (state, payload) => {
      return payload;
    }
  },
  true
);
